export const CONFIGURE_SUBSCRIPTION_RENEWAL_OVERLAP = 'configure-subscription-renewal-overlap';

export const APP_NAME = 'voyager-app';
